import React, { useEffect, useRef, useState } from 'react';
import api from '../services/api';
import arrowIcon from '../assets/images/Arrow.svg';
import "../styles/dataTable.css";
import searchIcon from '../assets/images/search_icon.svg';
import editIcon from '../assets/images/edit_icon.svg';
import { useNavigate } from 'react-router-dom';
import addIcon from '../assets/images/add-icon.svg';
import { toast } from 'react-toastify';

const ManagePlan = () => {

  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);

  // Table state
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  // Only Service Plan List is used on this page.

  const filteredData = plans.filter((item) =>
    Object.values(item).join(" ").toLowerCase().includes(search.toLowerCase())
  );

  if (sortField) {
    filteredData.sort((a, b) => {
      const valA = a[sortField];
      const valB = b[sortField];
      if (typeof valA === "number") {
        return sortOrder === "asc" ? valA - valB : valB - valA;
      } else {
        return sortOrder === "asc"
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      }
    });
  }

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  // (Provider-related views removed; this page shows only Service Plan List)

  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(1);
  }, [search, entriesPerPage, totalPages, currentPage]);

  // (Removed: Who Taken Plan tab and related fetch on tab change)

  // Sort Toggle Handler
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  // Fetch API data
  useEffect(() => {
    fetchPlans();
  }, []);

  // Refetch when forms close
  useEffect(() => {
      fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      const response = await api.get('/service-plan/get-all');
      const all = response.data.data || [];
      console.log('Fetched plans data:', all);
      // Show all plans (active and inactive) so admin can toggle status like ManageVendor
      setPlans(all);
    } catch (error) {
      console.error('Error fetching plans data:', error);
      toast.error('Error fetching plans');
    }
  };





  const handleStatusToggle = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === '1' || currentStatus === 1 ? 0 : 1;
      // Use dedicated isactive endpoint (same pattern as ManageVendor)
      await api.post(`/service-plan/isactive/${id}`, { isactive: newStatus });
      // Refresh plans list to reflect server state
      await fetchPlans();
      toast.success('Plan status updated');
    } catch (error) {
      console.error('Error updating plan status:', error);
      toast.error('Error updating plan status');
    }
  };

  const handleCreatePlanClick = () => {
    navigate('/plan-types/add');

  };

  const handlePlanUpdate = (id) => {
    navigate(`/plan-types/edit/${id}`);
  };

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      {/* Backdrop overlay removed for Create/Update plan forms to avoid full-screen fixed inset style */}

      <div style={{ padding: "20px" }}>
        {/* Service Plan List (only) */}
        <>
          <div className="table-header">
            <h2 style={{ fontWeight: 700 ,fontSize: "26px" }}>Plan Types</h2>

            <div className="search-container">
              <input
                type="text"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
                placeholder="search"
              />
              <img src={searchIcon} alt="search-icon" className="search-icon" />
            </div>

            <div className="entries-container">
              <label htmlFor="noOfEntries">Show: </label>
              <select
                value={entriesPerPage}
                id="noOfEntries"
                onChange={(e) => setEntriesPerPage(Number(e.target.value))}
              >
                <option value={10}>10 Entries per page</option>
                <option value={50}>50 Entries per page</option>
                <option value={100}>100 Entries per page</option>
              </select>
            </div>

            <div className="action-btn">
              <button onClick={handleCreatePlanClick}>
                <img src={addIcon} alt="add-icon" /> Add Plan
              </button>
            </div>
          </div>

          {/* Table */}
          <table width="100%" cellPadding="10" className="table-no-outer-border">
            <thead>
              <tr>
                <th onClick={() => handleSort("plan_name")}>Plan Name ▽△</th>
                <th onClick={() => handleSort("plan_type")}>Plan Type ▽△</th>
                <th onClick={() => handleSort("price")}>Price ▽△</th>
                <th onClick={() => handleSort("noofpackge")}>No. of Packages ▽△</th>
                <th onClick={() => handleSort("duration_days")}>Duration (Days) ▽△</th>
                <th onClick={() => handleSort("rank")}>Rank ▽△</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((plan) => (
                  <tr key={plan.id}>
                    <td>{plan.plan_name}</td>
                    <td>{plan.plan_type}</td>
                    <td>₹ {parseFloat(plan.price).toLocaleString('en-IN')}</td>
                    <td>{plan.noofpackge}</td>
                     <td>{plan.duration_days}</td>
                    <td>{plan.rank}</td>
                   
                    <td className='text-center align-middle'>
                      {(() => {
                        const isActiveFlag = plan.isactive === '1' || plan.is_active === '1' || plan.isactive === 1 || plan.is_active === 1;
                        return (
                          <div className="custom-toggle-switch">
                            <input
                              type="checkbox"
                              className="custom-toggle-input"
                              checked={!!isActiveFlag}
                              onChange={() => handleStatusToggle(plan.id, isActiveFlag ? '1' : '0')}
                              id={`toggle-${plan.id}`}
                            />
                            <label className="custom-toggle-label" htmlFor={`toggle-${plan.id}`}>
                              <span className="custom-toggle-text">
                                {isActiveFlag ? 'Active' : 'Inactive'}
                              </span>
                            </label>
                          </div>
                        );
                      })()}
                    </td>
                    <td className='text-center align-middle action-icons' style={{display: 'flex', }}>
                      <button
                        className='edit-button'
                        onClick={() => handlePlanUpdate(plan.id)}
                        style={{ marginRight: '10px' }}
                      >
                        <img src={editIcon} alt="editIcon" /> Edit
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} style={{ textAlign: "center" }}>No data found</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination */}
          <div style={{ paddingBottom: '30px', background: '#fff' }}>
            <div
              style={{
                padding: "30px",
                textAlign: "center",
                borderTop: '2px solid #F2F2F2',
                borderBottom: '2px solid #F2F2F2'
              }}
            >
              <button
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={{
                  margin: "0 5px",
                  border: "none",
                  background: "#fff",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer"
                }}
              >
                <img
                  src={arrowIcon}
                  alt="prev"
                  style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
                />
              </button>

              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  style={{
                    margin: "0 5px",
                    padding: "5px 10px",
                    background: currentPage === page ? "#D9D9D9" : "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer"
                  }}
                >
                  {page}
                </button>
              ))}

              <button
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                style={{
                  margin: "0 5px",
                  border: "none",
                  background: "#fff",
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer"
                }}
              >
                <img
                  src={arrowIcon}
                  alt="next"
                  style={{
                    opacity: currentPage === totalPages ? 0.5 : 1,
                    transform: "rotateY(180deg)"
                  }}
                />
              </button>
            </div>
          </div>
        </>

        {/* (Removed Who Taken Plan section - page shows only Service Plan List) */}
      </div>

    </div>
  );
};

export default ManagePlan;
